import { render } from "./NotificarAlumnos.vue?vue&type=template&id=3221d56c&scoped=true"
import script from "./NotificarAlumnos.vue?vue&type=script&lang=js"
export * from "./NotificarAlumnos.vue?vue&type=script&lang=js"

import "./NotificarAlumnos.vue?vue&type=style&index=0&id=3221d56c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3221d56c"]])

export default __exports__